import * as React from 'react';
import WidgetBox from '../../../../components/Layout/WidgetBox/WidgetBox';
import WidgetBoxContent from '../../../../components/Layout/WidgetBox/WidgetBoxContent';
import WidgetListItemLinkRow from '../../../../components/Layout/WidgetBox/WidgetListItemLinkRow';
import { IPromotionsAggregatedByBrandType } from '../../types/IPromotionsAggregatedByBrandType';

interface IPromotionsAggregatedByBrandsWidgetProps {
	aggregatedEntries: IPromotionsAggregatedByBrandType[];
	title: string;
	widgetKey?: string;
	promotionLabel?: string;
	promotionLabelPlural?: string;

	routeCallbk: (item: IPromotionsAggregatedByBrandType) => { name: string, params: {[key: string]: any} },
}

class PromotionsAggregatedByBrandsWidget extends React.Component<IPromotionsAggregatedByBrandsWidgetProps, {}> {
	public static defaultProps = {
		widgetKey: 'promotion-list-widget',
		promotionLabel: 'Aktion',
		promotionLabelPlural: 'Aktion',
	};

	public render() {
		const { aggregatedEntries, title, widgetKey, promotionLabel, promotionLabelPlural, routeCallbk } = this.props;

		return (
			<WidgetBox title={title}>
				<WidgetBoxContent>
					{aggregatedEntries.map((aggregatedEntry: IPromotionsAggregatedByBrandType) => {
						const route = routeCallbk(aggregatedEntry);

						return (
							<WidgetListItemLinkRow
								title={aggregatedEntry.group.name}
								subtitle={`${aggregatedEntry.totalItemsCount} ${ (aggregatedEntry.totalItemsCount === 1) ? promotionLabel : promotionLabelPlural}`}
								key={`${widgetKey}-${aggregatedEntry.group.slug}`}
								route={route.name}
								routeParams={route.params}
							/>
						);
					})}
				</WidgetBoxContent>
			</WidgetBox>
		);
	}
}

export default PromotionsAggregatedByBrandsWidget;
